import { Image as BaseComponent } from "lemans-brandsites-common/components/Image/Image.component";
import * as React from 'react';
import './Image.styles.less';
import { IImageProps } from "./Image.types";

export const Image = (props:IImageProps) => <BaseComponent {...props} />;
